import { fetchApi } from '@coconut/services/apis/utils';

export const getCurriculums = () => fetchApi('api/v2/curriculums');

export const getSubjects = (curriculumId) =>
  fetchApi(`api/v3/students/subjects?curriculum_id=${curriculumId}`);



// WEBPACK FOOTER //
// ./src/services/apis/curriculum.js